/**
 * Response Parsing Utilities
 * Handles parsing of HTTP responses based on content type
 */

import { CONTENT_TYPES } from "./constants";

export async function parseResponse<T>(response: Response): Promise<T> {
  const contentType = response.headers.get("content-type");

  // No content
  if (response.status === 204) {
    return undefined as T;
  }

  // JSON response
  if (contentType?.includes(CONTENT_TYPES.JSON)) {
    return response.json();
  }

  // Text fallback
  const text = await response.text();
  return text as unknown as T;
}
